import type { PresetColorType } from 'antd/es/_util/colors';

import type { VCC_STATUS } from 'app/typings/core/common/enum/vccStatus';

type FormatVccStatus = {
  [key in VCC_STATUS]: {
    label: string;
    color?: PresetColorType;
  };
};

export const formatVccStatus = (
  vccStatus: VCC_STATUS
): FormatVccStatus[VCC_STATUS] => {
  const formatVcc: FormatVccStatus = {
    INACTIVE: {
      label: 'Inactive',
      color: undefined,
    },
    CANCELED: {
      label: 'Canceled',
      color: 'red',
    },
    TO_CHARGE: {
      label: 'To charge',
      color: 'blue',
    },
    CHARGED: {
      label: 'Charged',
      color: 'green',
    },
    TO_REFUND: {
      label: 'To refund',
      color: 'orange',
    },
    DEACTIVATED: {
      label: 'Deactivated',
      color: undefined,
    },
  };

  return formatVcc[vccStatus];
};
